export const OrcaPropTypes = [
  { name: "uuid", type: "string" },
  { name: "video", type: "object" },
  { name: "config", type: "object" },
  { name: "isSandbox", type: "boolean" }
];

export const Events = {
  PROPS_UPDATED: "orca-player-props-updated"
};
